import { Component, Output, EventEmitter, HostListener } from '@angular/core';

@Component({
    selector: 'app-confirm-exit-modal',
    templateUrl: './confirm-exit-modal.component.html',
    styleUrls: ['./confirm-exit-modal.component.scss'],
    standalone: false
})
export class ConfirmExitModalComponent {
  @Output() close = new EventEmitter();
  @Output() success = new EventEmitter();
  public showExitConfirmModal: boolean = false;
  public showMessage = true;

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (event.key === 'Escape' && this.showExitConfirmModal) {
      event.preventDefault();
      this.fnCloseConfirmExitModal();
    }
  }

  confirmExitEmployee() {
    this.fnCloseModal();
    this.success.emit();
  }

  fnOpenConfirmExitModal(showExitModal: boolean, modalType?: string) {
    if (modalType === 'campus-employee') {
      this.showMessage = false;
    }
    this.showExitConfirmModal = showExitModal;
    (<any>$('#confirmExitModal')).modal('show');
  }

  fnCloseConfirmExitModal() {
    this.fnCloseModal();
    this.close.emit();
  }

  fnCloseModal() {
    this.showExitConfirmModal = false;
    (<any>$('#confirmExitModal')).modal('hide');
  }
}
